import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ModalService } from 'src/app/shared/services/modal.service';
import { EmployeeReportDialogComponent } from '../employee-report-dialog/employee-report-dialog.component';
import { Store } from '@ngrx/store';
import { notasFiscaisReportActions } from 'src/app/store/notas-fiscais-report/notas-fiscais-report.actions';
import { selectNotasFiscaisReport } from 'src/app/store/notas-fiscais-report/notas-fiscais-report.selectors';
import { INotasFiscaisReport } from 'src/app/shared/interfaces/notasFiscaisReport/inotasfiscaisreport';
import { loadProfessional } from 'src/app/store/professional/professional.actions';
import { selectProfessionalLista } from 'src/app/store/professional/professional.selectors';

@Component({
  selector: 'app-notas-fiscais-report',
  templateUrl: './notas-fiscais-report.component.html',
  styleUrls: ['./notas-fiscais-report.component.scss']
})
export class NotasFiscaisReportComponent implements OnInit {

  applyFilterEmissao: boolean = false;
  applyFilterProfissional: boolean = false
  professionalFilterOptions!: any[]
  selectedEmployeeFilter!: string

  notasFiscaisReport$ = this.store.select(selectNotasFiscaisReport)
  professionalList$ = this.store.select(selectProfessionalLista)
  chartLabel = ['01/23', '02/23', '03/23', '04/23', '05/23', '06/23', '07/23', '08/23', '09/23', '10/23', '11/23', '12/23']
  chartData = [
    {
      legend: 'Relatorio Notas Fiscais',
      data: [14000, 9000, 10000, 6000, 8000, 12000, 12500, 12000, 14000, 13000, 15000, 12185.12],
      gradientColors: ['rgba(109, 108, 205, 1)', 'rgba(255, 255, 255, 0)']
    }
  ]

  filtroEmissao = [
    {
      label: 'Sim',
      //icon: 'pi pi-refresh',
      command: () => {
        this.addFilterEmissao('Sim');
      }
    },
    {
      label: 'Não',
      // icon: 'pi pi-times',
      command: () => {
        this.addFilterEmissao('Não');
      }
    }
  ]

  // filtroProfissional = [
  //   {
  //     label: 'Carlos Henrique',
  //     //icon: 'pi pi-refresh',
  //     command: () => {
  //       this.addFilterProfissional('Carlos Henrique');
  //     }
  //   },
  //   {
  //     label: 'Amanda Gomes',
  //     // icon: 'pi pi-times',
  //     command: () => {
  //       this.addFilterProfissional('Amanda Gomes');
  //     }
  //   },
  //   {
  //     label: 'Gabriel Santos',
  //     // icon: 'pi pi-times',
  //     command: () => {
  //       this.addFilterProfissional('Gabriel Santos');
  //     }
  //   },
  //   {
  //     label: 'Todos',
  //     // icon: 'pi pi-times',
  //     command: () => {
  //       this.removeFilterProfissional();
  //     }
  //   }
  // ]

  form = this.fb.group({
    economia_mes_a_mes: [[
      {
        label: '',
        data: 0
      }
    ]],
    notas_fiscais_empresa: [[{
      nome_unidade: "",
      qtd_atendimentos: "",
      NF_automatica: true,
      qtd_NF_emitidas: "",
      qtd_NF_contabilidade: "",
      qte_erro: "",
      valor_notas: "",
      comparativo_notas_mes_anterios_porcentagem: ""
    }]],
    notas_fiscais_profissional: [[
      {
        nome_profissional: "",
        qtd_atendimentos: "",
        NF_automatica: true,
        qtd_NF_emitidas: "",
        qtd_NF_contabilidade: "",
        qtd_erro: "",
        valor_notas: "",
        valor_economia_IR: "",
        comparativo_notas_mes_anterior_porcentagem: "",
        notas: [
          {
            data_emissao: "",
            nome_paciente: "",
            nome_servico: "",
            convenio: "",
            valor_total_servico: "",
            valor_centro: "",
            valor_especialista: ""
          }
        ]
      }
    ]],
    total_notas_ficais_profissionais: [{
      total_qtd_atendimentos: "",
      total_qtd_NF_emitidas: "",
      total_qtd_NF_contabilidade: "",
      total_qte_erro: "",
      total_valor_notas: "",
      total_valor_economia_IR: "",
      total_comparativo_notas_mes_anterios_porcentagem: ''
    }],
  })

  professionalFilteredId = null

  constructor(
    private fb: FormBuilder,
    public modalService: ModalService,
    private store: Store
  ) { }

  ngOnInit(): void {
    this.professionalList$.subscribe({
      next: res => {
       this.professionalFilterOptions = res.filter( professional => 
        professional.isActive == true
       )
      }
    })
    //this.store.dispatch(notasFiscaisReportActions.loadNotasFiscaisReport())
    this.store.dispatch(loadProfessional());

    this.notasFiscaisReport$.subscribe({
      next: (res: INotasFiscaisReport) => {
        if (res != null || undefined) {

          this.form.setValue({
            economia_mes_a_mes: res.economia_mes_a_mes,
            notas_fiscais_empresa: [res.notas_fiscais_empresa],
            notas_fiscais_profissional: res.notas_fiscais_profissional,
            total_notas_ficais_profissionais: res.total_notas_ficais_profissionais
          })

          /* console.log('form after setValue: ', this.form.value) */
        }
      }
    })

  }

  addFilterOptions(event: any) {
    //integrar filtragem pela API

    console.log('event: ', event)
  }


  addFilterEmissao(option: string) {
    //console.log('addFilterEmissao funcionou')
    this.applyFilterEmissao = true

  }

  removeFilterEmissao() {
    //console.log('cancelFilterEmissao funcionou')
    this.applyFilterEmissao = false
  }

  addFilterProfissional() {
    console.log('professional selecionado: ', this.professionalFilteredId)
  }

  removeFilterProfissional() {
    this.selectedEmployeeFilter = ''
    this.applyFilterProfissional = false
  }

  openReportByEmployee(name: string, notas: any) {
    this.modalService.show(EmployeeReportDialogComponent, `Relatório ${name}`, notas)
  }


}
